import React, { useState } from 'react';
import { FaCommentDots, FaWhatsapp, FaTimes } from 'react-icons/fa';
import './CustomerSupport.css';

const CustomerSupport = () => {
  const [isOpen, setIsOpen] = useState(false);
  const supportPhone = '255747636516'; // Whatapp number wa HarusiOnline, au msaidizi

  const toggleSupport = () => {
    setIsOpen(!isOpen);
  };

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${supportPhone}?text=Habari, nahitaji msaada kuhusu HarusiOnline`, '_blank');
    setIsOpen(false);
  };

  return (
    <div className="customer-support-widget">
      {isOpen && (
        <div className="support-menu fade-in-up">
          <div className="support-header">
            <h6 className="mb-0 fw-bold text-white">HarusiOnline Support</h6>
            <button className="close-btn-support" onClick={toggleSupport}>
              <FaTimes />
            </button>
          </div>
          <div className="support-body">
            <p className="text-muted small mb-3">
              Karibu! Je, unahitaji msaada wowote au una swali kuhusu mfumo?
            </p>
            <button className="btn-whatsapp-support w-100" onClick={handleWhatsAppClick}>
              <FaWhatsapp className="me-2 fs-5" /> Wasiliana Nasi
            </button>
          </div>
        </div>
      )}

      <button
        className={`support-fab shadow-lg ${isOpen ? 'active' : ''}`}
        onClick={toggleSupport}
        title="Customer Support"
      >
        <FaCommentDots size={28} />
      </button>
    </div>
  );
};

export default CustomerSupport;
